import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

export default function EulaDialog(props) {
    const { open, handleClose, user } = props;

    const formatEulaVersion = (version) => {
        if(version) {
            const parts = version.split(".");
            while (parts.length > 1 && parts[parts.length - 1] === "0") {
                parts.pop();
            }
            return ` - (v${parts.join(".")})`;
        }
        return ` - (v1)`;
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">PARTICIPATION AND END USER LICENSE AGREEMENT (EULA) {formatEulaVersion(user?.latestEulaVersion)}</DialogTitle>
            <DialogContent dividers={true}>
                <div className="MuiTypography-root MuiDialogContentText-root MuiTypography-body1 MuiTypography-colorTextSecondary"
                    dangerouslySetInnerHTML={{
                            __html: user?.latestEulaContent
                        }}>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}